/* ==========================================================================
   HOUND - SHOPIFY POLICY PAGES
   ==========================================================================
   One job: hide the blank paragraphs Shopify's policy editor leaves behind.

   Policy copy is pasted rich text, and the editor preserves every spacer line as
   its own paragraph. On the refund policy that is 39 blank paragraphs out of 62,
   which is what produced the ragged hundred-pixel gaps between sections.

   CSS cannot do this alone: `:empty` matches neither `<p> </p>` (a whitespace text
   node) nor `<p><br></p>` (an element child), and there is no selector for "holds
   nothing but whitespace". Hence ten lines of JS rather than a clever hack.

   Layout-only, so it is safe to run late; nothing here changes what the policy
   says, only the vertical rhythm it is set in.
   ========================================================================== */
(function () {
  'use strict';

  function tidy() {
    var body = document.querySelector('.shopify-policy__body');
    if (!body) return;

    Array.prototype.forEach.call(body.querySelectorAll('p'), function (p) {
      if (p.textContent.trim()) return;
      /* A paragraph can be textless and still carry meaning. */
      if (p.querySelector('img, svg, iframe, video, picture, object')) return;
      p.hidden = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tidy);
  } else {
    tidy();
  }
})();
